import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Modal, Spinner } from "react-bootstrap";

import "swiper/css";
import "swiper/css/navigation";

import vediobrn from "../../../assets/images/video-btn.svg";
import defaultImage from "../../../assets/images/default-image.png";
import { apiData } from "../../../actions";
import { useSelector } from "react-redux";

export default function SliderFirst({ tourData = [] }) {
  const place = useSelector((state) => state.place);
  const [play, setPlay] = useState(false);
  const [loader, setLoader] = useState(false);
  const [audioData, setAudioData] = useState(null);

  const handleClick = async (id) => {
    if (!id) return;

    setPlay(true);
    setLoader(true);

    try {
      const payload = { audioId: id };
      const apiRes = await apiData.getShadowAudio(payload);

      if (apiRes?.status >= 200 && apiRes?.status <= 399) {
        setAudioData(apiRes?.data?.data || null);
      }
    } catch (err) {
      console.error("Audio API Error:", err);
    } finally {
      setLoader(false);
    }
  };

  if (!place) {
    return <p className="text-center">No Tours Available, Please Select City</p>;
  } else if (!tourData?.length) {
    return <p className="text-center">No Tours Available</p>;
  }

  console.log("tourDatatourData", tourData)
  return (
    <>
      <div className="container-fluid">
        {tourData.map((tour) => (
          <div key={tour?.uuid} className="mb-5">
            {/* SECTION TITLE */}
            <div
              className="section-top-heading mb-2 mb-md-4 uk-scrollspy-inview"
              uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
            >
              <h2>{tour?.title}</h2>
            </div>

            {/* SLIDER */}
            {tour?.imagesData?.length > 0 ? (
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                loop
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                navigation
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                  1400: { slidesPerView: 4 },
                }}
                className="audioTureslider pb-70"
              >
                {tour?.imagesData?.map((ele) => (
                  <SwiperSlide className="col-md-6 col-lg-4" key={ele?.main_uiid}>
                    <div
                      className="audio_tour_box position-relative"
                    >
                      {/* IMAGE */}
                      <figure>
                        <img
                          src={ele?.image_url || defaultImage}
                          alt={ele?.tour_title}
                          className="img-fluid"
                          onClick={() => handleClick(ele?.main_uiid)}
                          style={{ cursor: "pointer" }}
                        />
                      </figure>
                      <div className="audio-content things">
                        <p>
                          {ele?.tour_title.split(" ").length > 3
                            ? `${ele?.tour_title
                              .split(" ")
                              .slice(0, 3)
                              .join(" ")}...`
                            : ele?.tour_title.split(" ").slice(0, 3).join(" ")}
                        </p>
                      </div>

                      {/* PLAY BUTTON */}
                      <button
                        type="button"
                        className="bg-transparent border-0 position-absolute top-50 start-50 translate-middle"
                        style={{ zIndex: 9 }}
                        onClick={() => handleClick(ele?.main_uiid)}
                      >
                        <img src={vediobrn} alt="Play Audio" />
                      </button>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <p>No images available</p>
            )}
          </div>
        ))}
      </div>

      {/* AUDIO MODAL */}
      <Modal show={play} onHide={() => setPlay(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{audioData?.title || "Audio Tour"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loader ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              {audioData?.audio_url && (
                <audio
                  src={audioData?.audio_url}
                  controls
                  autoPlay
                  className="w-100 mb-3"
                />
              )}

              {audioData?.description && (
                <div
                  className="audio_text"
                  dangerouslySetInnerHTML={{
                    __html: audioData?.description,
                  }}
                />
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
